
import * as React from 'react';
import { useState, useEffect, useCallback , useRef}  from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
import { app } from '../../config/app.js';
import {  getPermission } from '../../controller/user.js';
import {  getDataByKey } from '../../controller/firestore.js';
import {  getData } from '../../controller/firestore.js';
import { updateDocToDb } from '../../controller/firestore.js';
import {UserCategoryForm} from '../../config/collections/guide.js'; // Adjust the path as necessary

import { Firma } from '../../components/Firma.js';
import dayjs from 'dayjs';
import { DateTimeField } from '@mui/x-date-pickers/DateTimeField';

import { DateField } from '@mui/x-date-pickers';
import {  Navigate , Link } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { useLocation } from 'react-router-dom';

import { convertDatetime } from '../../controller/utils.js';
import Stack from '@mui/material/Stack';
import { Button, ButtonGroup } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ConfirmDialog } from '../../components/Confirm.js';
import { useNavigate } from 'react-router-dom';


export function ViewEditGuida(props) {
  const user = props.user
  const originalDocGuidaRef = useRef(null);
  const collectionName = "guide";
  const location = useLocation();
  const previousUrlRef = useRef(document.referrer);
  const navigate=useNavigate();
  const httpdata = location.state && location.state.data;
  const modeDefault=props.mode; // view, edit
  const [mode, setMode] = useState(modeDefault);
  const id = (httpdata && httpdata.id ? httpdata.id : null);
  const category=(httpdata.docData && httpdata.docData.category?httpdata.docData.category:null);
  const [hasStored,setHasStored]=useState(false);
  const activePermission = getPermission("collection", collectionName, null, user);
  
  const collectionConfig = app.collections_config[collectionName];
  const categoryScheme=collectionConfig.questionCfg.categoryScheme[category];
  const [docGuida, setDocGuida] = useState(httpdata.docData ? {...httpdata.docData.docData,"id":httpdata.docData.id}: null );
  const [errorMessageHeader, setErrorMessageHeader] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [innerChanged, setInnerChanged] = useState(null);
  
  const [firmaData, setFirmaData] = useState(docGuida.firma);
  const currentPath = location.pathname;
  
  const [reloadIstruttori,setReloadIstruttori]=useState(true);
  const [istruttori, setIstruttori] = useState([]);

  useEffect(() => {
    const fetchIstruttori = async () => {
      const activePermission=getPermission("collection","utenti",null,user);
      const params={
        //"orderBy":orderBy,
    //    "pageSize":pageSize,
    //    "page":currentPage,
    //    "startAfter":cursor,
        "permission":activePermission,        
        "user":user,
        "where":[
          [ "isIstruttore", "==", 1 ],
          [ "stato", "==", 1 ],
        ]
      };
      try {
        const data = await getData("utenti", app.collections_config["utenti"]["views"]["table"], params);
        const istruttoriMap = {};
        data["body"].forEach(istruttore => {
          
            
          istruttoriMap[istruttore.id] = { nome:istruttore.nome, cognome:istruttore.cognome, nomeBreve:istruttore.nome+' '+istruttore.cognome.substring(0,1) };            
          
        });
        setIstruttori(istruttoriMap);
       // console.log("Istruttori", istruttoriMap);
        setReloadIstruttori(false);
      } catch (error) {
        setErrorMessageHeader("Errore");
        setErrorMessage("Error fetching istruttori: " + error.message);
      }
    };
    if (reloadIstruttori)
    fetchIstruttori();
  }, []);

  const handleChange = (field, value) => {
    setDocGuida(prevState => ({
      ...prevState,
      [field]: value
    }));
  };
   async function saveGuidaClick() {
    if (!docGuida.istruttore) {
      setErrorMessageHeader("Errore");
      setErrorMessage("Il campo 'Istruttore' non è compilato.");
      return;
    }
    if (!docGuida.date) {
      setErrorMessageHeader("Errore");
      setErrorMessage("Il campo 'Data' non è compilato.");
      return;
    }
    if (!docGuida.durata) {
      setErrorMessageHeader("Errore");
      setErrorMessage("Il campo 'Durata' non è compilato.");
      return;
    }
    if (!docGuida.hasOwnProperty("creationDatetime")) {
      docGuida["creationDatetime"] = dayjs().$d;
      docGuida["creationUser"] = user.uid;
      docGuida["creationUserName"] = user.db.nome+' '+user.db.cognome;
    } else  docGuida["creationDatetime"] = dayjs(convertDatetime(docGuida["creationDatetime"])).$d;
    docGuida["modificationDatetime"] = dayjs().$d;
    docGuida["modificationUser"] = user.uid;
    docGuida["modificationUserName"] = user.db.nome+' '+user.db.cognome;
    docGuida.date=dayjs(docGuida.date).$d;
    if (firmaData) {
      firmaData["datetime"]=dayjs(convertDatetime(firmaData.datetime)).$d;
    }
    docGuida["firma"]=firmaData;
    docGuida.schemeRaw=JSON.stringify(docGuida.scheme);
    delete docGuida.scheme;
      // Update existing doc
      const esito=await updateDocToDb(collectionName, null,docGuida.id, docGuida);
      if (esito[0]){
        setErrorMessageHeader("Avviso");
        setErrorMessage("Guida aggiornata correttamente");
        console.log("Guida aggiornata correttamente");
        //setHasStored(true);
        navigate(-1);
      }
      else {
        const error=esito[1];
        setErrorMessageHeader("Errore");
        setErrorMessage("Errore nell'aggiornamento della guida: " + error.message);
        console.error("Errore nell'aggiornamento della guida: " + error.message);
      };
    
  };
  const [openSwitchDialog,setOpenSwitchDialog]=useState(false);
  const switchModeButtons=[
      {
        name:"gotoView-"+docGuida.id+"-ok",
        text:"CONFERMO",
        callback: async function () {
          
          setOpenSwitchDialog(false);
          if (originalDocGuidaRef.current) {
           
            setDocGuida(originalDocGuidaRef.current);
            setFirmaData(originalDocGuidaRef.current.firma);
          }
          setMode("view");
          
        }
      },
      {
        name:"gotoView-"+docGuida.id+"-ko",
        text:"Annulla",
        callback: function () {
          setOpenSwitchDialog(false);
        }
      }
  
    ];
    
  const [openConfirmSaveDialog,setOpenConfirmSaveDialog]=useState(false);
  const confirmSaveModeButtons=[
      {
        name:"update-"+docGuida.id+"-ok",
        text:"Salva",
        callback: async function () {
          
          setOpenConfirmSaveDialog(false);
          saveGuidaClick();
          
        }
      },
      {
        name:"update-"+docGuida.id+"-ko",
        text:"Annulla",
        callback: function () {
          setOpenConfirmSaveDialog(false);
        }
      }
  
    ];
  useEffect(() => {   
    const date = new Date(docGuida.date.seconds * 1000); // Converti in JavaScript Date

    if (docGuida && !docGuida.scheme && docGuida.schemeRaw) {
   //   console.log("Settato REF ORIGINALE");
      originalDocGuidaRef.current = {
        ...docGuida,
        detail: { ...docGuida.detail }
      };

      setDocGuida(prevState => ({
        ...prevState,
        scheme: JSON.parse(docGuida.schemeRaw),
        date: date
      }));
    }
  }, [docGuida]);
  return (
    <div>
      <Dialog
      open={errorMessage !== ""}
      onClose={() => { setErrorMessageHeader(""); setErrorMessage("")}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      >
      <DialogTitle id="alert-dialog-title">{errorMessageHeader}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
        {errorMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => {setErrorMessageHeader(""); setErrorMessage("")}} color="primary" autoFocus>
        Chiudi
        </Button>
      </DialogActions>
      </Dialog>
      {hasStored === true ? (
      <Navigate to={previousUrlRef} state={{ data: {  } }} />
      ) : (
      <>
           <ConfirmDialog 
                   key={docGuida.id+"-switchMode"} 
                   title='Attenzione' 
                   message='Tornando alla modalità VISUALIZZA perderai tutte le modifiche non salvate. Continuare?' 
                   buttons={switchModeButtons} 
                   onClose={switchModeButtons[1].callback} 
                   open={openSwitchDialog} 
                   setOpen={setOpenSwitchDialog} 
                   /> 

            <ConfirmDialog 
                   key={docGuida.id+"-update"} 
                   title='Attenzione' 
                   message='La Guida precedentemente inserita verrà modificata. Continuare?' 
                   buttons={confirmSaveModeButtons} 
                   onClose={confirmSaveModeButtons[1].callback} 
                   open={openConfirmSaveDialog} 
                   setOpen={setOpenConfirmSaveDialog} 
                   /> 
          <ButtonGroup sx={{ mb: 5 }} variant="contained" aria-label={`button group`}>
          {mode==="view" && <Button
            sx={{ fontSize: '20px', padding: '10px 20px' }}
            variant='contained'
            color='success'
            onClick={() => { setMode("edit")
            }
            }
          >
            Vai a MODIFICA
          </Button> }

          {mode==="edit" && <Button
            sx={{ fontSize: '20px', padding: '10px 20px' }}
            variant='contained'
            color='success' onClick={() => {
              
            setOpenSwitchDialog(true);
            /*
              if (originalDocGuidaRef.current) {
           
                setDocGuida(originalDocGuidaRef.current);
              }
              setMode("view");
              */
            
            }}
          >Vai a modalità VISUALIZZA
          </Button> }
          </ButtonGroup>
        
        <div style={{ backgroundColor: mode === "edit" ? "yellow" : "transparent" }}>
          <Typography  sx={{ mb: 2 }}  variant="h6" component="h6"><b>CANDIDATO: </b> 
          {docGuida.candidatoName} (Cat. {app.category[category]})
          </Typography>
          {false && <Typography  sx={{ mb: 2 }}  variant="h6" component="h6"><b>Istruttore: </b> 
          {docGuida.istruttoreNome} {docGuida.istruttoreCognome}
          </Typography>}
          {false && 
          <Typography  sx={{ mb: 2 }}  variant="h6" component="h6"><b>Data: </b> 
          {dayjs(docGuida.date).format('DD/MM/YY')+'\n'+dayjs(docGuida.date).format('HH:mm')} {app.durate[docGuida.durata]}
          </Typography>}
          <div>
          <FormControl sx={{ m: 1, minWidth: 300 }}>
            <InputLabel id="guida-istruttore-label">Istruttore *</InputLabel>
            <Select
            labelid="guida-istruttore-label"
            id="guida-istruttore"
            variant="outlined"
            value={docGuida.istruttore}
            disabled={mode === "view"}
            onChange={(e) => handleChange('istruttore', e.target.value)}
            label="Istruttore"
            required={true}
            >
            <MenuItem key='' value='' disabled>Non selezionato</MenuItem>
            {Object.entries(istruttori).map(([key, istrObj]) => (

              <MenuItem key={key} value={key}>
              {istrObj.nome} {istrObj.cognome}
              </MenuItem>
            ))}
            </Select>
          </FormControl>
          </div>
          <div>
          <DateTimeField
          sx={{ m: 1 }}
            onChange={(e) => handleChange('date', e.$d)}
            variant="outlined"
            required={true}
            labelid="guida-guida-label"
            id="newguida-date"
            disabled={mode === "view"}
            name="date"
            label="Data"
            value={dayjs(docGuida.date)}
          />
          <FormControl sx={{ m: 1 }}>
            <InputLabel id="guida-durata-label">Durata *</InputLabel>
            <Select
            id="guida-durata"
            labelid="guida-durata-label"
            value={docGuida.durata}
            variant="outlined"
            disabled={mode === "view"}
            required={true}
            onChange={(e) => handleChange('durata', e.target.value)}
            >
            {Object.entries(app.durate).map(([key, label]) => (
              <MenuItem key={key} value={key}>
              {label}
              </MenuItem>
            ))}
            </Select>
          </FormControl>
          </div>
          <UserCategoryForm guida={docGuida} changeGuidaObj={setDocGuida} mode={mode} />
          <div>
            <Typography variant="h6" component="h6">Note</Typography>
            <TextField
                variant="outlined"
                value={docGuida.note}
                onChange={(e) => handleChange('note', e.target.value)}
                label=""
                
                multiline
                rows={4}
                fullWidth
            />
        </div>
        
        <div>
            <Typography variant="h6" component="h6" sx={{ mt: 5 }}>Firma candidato</Typography>
            <Firma firmaData={firmaData} setFirmaData={setFirmaData} user={user} modify={mode==="edit"}></Firma>
        </div>
        {mode==="edit" && (
        <ButtonGroup sx={{ mt: 5 }} variant="contained" aria-label={`button group`}>
          <Button
            sx={{ fontSize: '20px', padding: '10px 20px' }}
            variant='contained'
            color='success'
            onClick={() => setOpenConfirmSaveDialog(true)}
          >
            {id == null ? "Salva" : "Modifica"}
          </Button>
          </ButtonGroup>)}
        </div>
        
      </>
      )}
    </div>
    );
}